<div class="fake-icon">?</div>
<p>
  {{ 'Connecting to Schematix' | translate }}
  {{ '... Make sure the Schematix system is powered on and connected to the network.' | translate }}
</p>
